export default __webpack_public_path__ + "3240f09d8d33b3d02f232f4f17517343.svg";